import React from 'react'
import Button from '../Button'
import CheckEnabledSVG from '../SVG/CheckEnabled'
import CheckDisabledSVG from '../SVG/CheckDisabled'
export default function CheckBox({ title, value, size = 'sm1', activeColor = "#dc3545", onValueChanged,...props }) {
    return (

        <Button onClick={() => onValueChanged(!value)} {...props}>
            {!value ?
                <CheckDisabledSVG size={size} color={activeColor}
                    variant="c-prim"
                />
                :
                <CheckEnabledSVG size={size} color="#ff3347"
                    variant="c-prim"
                />
            }
            {title}
        </Button>

    )
}
